import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';

function RequirementsTagging({
  updateApplicationRequirementsSmartCity,
  getSelectedTypeListSmartCity,
  getRequirementList,
  isLoading,
}) {
  const [formData, setFormData] = useState([])
  const [formInput, setFormInput] = useState([])
  const [mode, setMode] = useState(false);
  const [isCancelled, setIsCancelled] = useState(false)

  // toggle checkboxes
  const handleToggle = (item, type) => () => { 
    setMode(true)
    // determine selected checkbox type
    const selectedRequirement = { type, requirement_id: [ item.requirement_id] }
    // check if new item
   if (_.isEmpty(formData)) setFormData([ ...formData, selectedRequirement])

   // check if select type already exist in formData
   if (!_.isEmpty(formData)) {
    const findReqType = formData.find(x => x.type === type)

    // if type does not exist yet
    if (!_.some(findReqType)) setFormData([ ...formData, selectedRequirement])

    // if type already exists
    if (_.some(findReqType)) {
      const newRequirementTag = formData
        .filter(x => x.type === type)
        .map(data => {

        // if selected requirement_id already exist
        if (data.requirement_id.find(x => x === item.requirement_id)) {
          return {
            type: data.type, 
            requirement_id: data.requirement_id.filter(i => i !== item.requirement_id)
          }
        }

        return {
          type: data.type, 
          requirement_id: _.concat(item.requirement_id, data.requirement_id)
        }
      })

      setFormData([
        ...formData?.filter(x => x.type !== type), // retain unchanged types
        ...newRequirementTag, // insert type with updated requirement_ids
      ])
    }}
   }

  const handleCancel = () => {
    setIsCancelled(!isCancelled)
    setTimeout(() => setMode(false), 500)
  };

  // submit
  const handleSubmit = e => {
    e.preventDefault()
    const args = formData || []
    args.forEach(item => updateApplicationRequirementsSmartCity(item))

    setTimeout(() => setMode(false), 500)
  }
  useEffect(() => {
    // fetch selected req list
    getSelectedTypeListSmartCity({}, async res => {
      const requirements = await _.get(res, "data")
      const formattedSelectedRequirements = requirements
        .map(item => ({
          id: _.get(item, "id"),
          type: _.get(item, "attributes.type"),
          name: _.get(item, "attributes.requirement_name"),
          requirement_id: _.get(item, "attributes.requirement_id"),
        })
      )
      
      // selected list
      const fetchRequirementsId = (type) => Object.values(
        _.groupBy(formattedSelectedRequirements
        .filter(x => x.type === type)
        .map(item => item.requirement_id), "type"))

      const fetchExistingRequirements = _.uniqBy(formattedSelectedRequirements.map(item => {
        const getReqId = fetchRequirementsId(item.type)
        return {
          type: item.type,
          requirement_id: _.reduce(getReqId)
        }
      }), "type")

      // reload formData to initial state
      if (isCancelled) {
        setFormData(fetchExistingRequirements)
      }
      setFormData(fetchExistingRequirements)
      setMode(false)
    })
        
    // fetch all req list
    getRequirementList({ display_all: 1}, async res => {
      const allRequirements = await _.get(res, "data")
      const tempTypes = ["QUARTERLY", "FULL"] // TODO: temporary fix for mapping tag types | update to dynamic types later
      const formattedRequirementsList = tempTypes.map(type => {
        return allRequirements
          .map(item => ({
            // type: _.get(item, "attributes.type"),
            type,
            name: _.get(item, "attributes.name"),
            requirement_id: +_.get(item, "id"),
          })
        )
      })

      setFormInput([
        ...formInput,
        ..._.flatten(formattedRequirementsList),
      ])
    })
  }, [isCancelled, ])

  const renderTagTypeLists = [..._.uniqBy(formInput, "type").map(x => x.type)]
  const renderTagLabel = [..._.uniqBy(formInput, "name")]

  return (  
    <div className="card p-0 card-requirements-tagging">
      <div className="">
        <div className="container-fluid p-4">
          <div className="row d-flex align-items-center px-3">
            <div className="col-6">
              <h2 className="font-weight-bold">
                Requirements Tagging
                {isLoading && <i className="fas fa-spinner fa-spin ml-3" />}  
              </h2>
            </div>
            {mode && (
              <>
                <div className="col-6 d-flex fade-in">
                  {/* actions button */}
                  <button
                    type="button"
                    className="btn btn-dark font-weight-bold ml-auto mr-2"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold"
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                </div>
                
              </>
            )}
            <hr className="w-100" />
          </div>
          {/* TABLE */}
          <div className="table-responsive mt-4">
            <table className="table table-borderless">
              <thead>
                {/* title */}
                <tr className="cms-bg-color-primary-light cms-text-primary">
                  <th scope="col" className="px-1">
                    Requirement Types
                  </th>
                  {renderTagTypeLists?.map(tagLabel => (
                    <th key={tagLabel} scope="col" className="px-1">
                      <div className="w-100 text-center">
                        {tagLabel}
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {/* content */} 
                {renderTagLabel?.map(item => {
                  return (
                    <tr key={`${item.type}-${item.requirement_id}`} className="top-border">
                      {/* label */}
                      <td className="font-weight-bold cms-text-muted-secondary py-3">
                        {item.name}
                      </td>
                      {/* checkbox */}
                      {renderTagTypeLists.map(type => {
                        const checkeSelectedTag = _.some(
                          formData.filter(x => x.type === type && 
                            x.requirement_id.find(id => id === item.requirement_id)
                          ))
                        return (
                          <td key={`${item.requirement_id}-${type}`} className="py-3">
                            <div className="w-100 text-center">
                              <button type="button" className="btn-blank" onClick={handleToggle(item, type)}>
                                {checkeSelectedTag ? 
                                  <i className="fas fa-check-square icon-check-box cms-text-primary" /> :
                                  <i className="far fa-square icon-check-box cms-text-primary" />
                                }
                              </button>
                            </div>
                          </td>
                        )
                      })}
                    </tr>
                  )})
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

RequirementsTagging.defaultProps = {
  isLoading: false
}

RequirementsTagging.propTypes = {
  // list of available requirements
  getRequirementList: PropTypes.instanceOf(Function).isRequired,
  // requirementList: PropTypes.instanceOf(Array).isRequired,
  // selected requirements
  getSelectedTypeListSmartCity: PropTypes.instanceOf(Function).isRequired,

  updateApplicationRequirementsSmartCity: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool
};

const mapStateToProps = ({ api }) => ({
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_SELECTED_TYPE_LIST) > -1,
  // requirementList: _.get(api, `${c.GET_REQUIREMENT_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withRouter,
  connect(
    mapStateToProps,
    actions,
  ),
]);

export default enhance(RequirementsTagging);
